/* Famous Glam — runtime.
   Three jobs: reveal on scroll, gate the rotation plates on capability,
   and drive the lens tint. Nothing else. No libraries. */
(function () {
  'use strict';

  var reduce = matchMedia('(prefers-reduced-motion: reduce)');

  /* Progressive enhancement flag. Copy is visible without JS; only once this
     class lands does anything start hidden and animate in. */
  document.documentElement.classList.add('fg-js');

  /* ---------- 1. reveals ---------- */
  function reveals() {
    var els = document.querySelectorAll('[data-fg-reveal]');
    if (!els.length) return;
    if (reduce.matches || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('fg-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('fg-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- 2. rotation plates, capability gated ----------
     A mid-range Android never downloads frames it cannot animate. We ship the
     three-quarter plate in the markup; the front and folded plates only get a
     real src once we know scroll-driven animation is available. */
  function plates() {
    var ok = false;
    try {
      ok = typeof CSS !== 'undefined' && CSS.supports &&
           CSS.supports('animation-timeline', 'view()');
    } catch (e) { ok = false; }
    if (!ok || reduce.matches) return;

    document.documentElement.classList.add('fg-scrub');
    document.querySelectorAll('img[data-fg-src]').forEach(function (img) {
      if (img.getAttribute('src')) return;
      var ss = img.getAttribute('data-fg-srcset');
      if (ss) img.setAttribute('srcset', ss);
      img.setAttribute('src', img.getAttribute('data-fg-src'));
    });
  }

  /* ---------- 3. per-product colourway ----------
     Each product owns its own swatches. Selecting one cross-fades the
     photograph, washes the plate in that lens's measured tint, and updates
     the price, the stock line and the link. Stock figures are real. */
  function products() {
    document.querySelectorAll('[data-fg-prod]').forEach(function (root) {
      if (root.dataset.fgBound === '1') return;
      var chips = [].slice.call(root.querySelectorAll('.fg-chip'));
      if (!chips.length) return;
      root.dataset.fgBound = '1';

      var a = root.querySelector('[data-stage-a]');
      var b = root.querySelector('[data-stage-b]');
      var nameEl = root.querySelector('[data-prod-colour]');
      var priceEl = root.querySelector('[data-prod-price]');
      var instalEl = root.querySelector('[data-prod-instal]');
      var stockEl = root.querySelector('[data-prod-stock]');
      var ctaEl = root.querySelector('[data-prod-cta]');

      function show(url, alt) {
        if (!url || !a || !b) return;
        var front = a.classList.contains('is-on') ? a : b;
        var back = front === a ? b : a;
        if (front.getAttribute('src') === url) return;
        back.onload = function () {
          back.classList.add('is-on');
          front.classList.remove('is-on');
          back.removeAttribute('aria-hidden');
          front.setAttribute('aria-hidden', 'true');
          back.alt = alt || '';
          front.alt = '';
        };
        back.src = url;
      }

      function apply(chip, focus) {
        root.style.setProperty('--tint-top', chip.dataset.vTop);
        root.style.setProperty('--tint-bottom', chip.dataset.vBottom);
        chips.forEach(function (c) {
          var on = c === chip;
          c.setAttribute('aria-checked', on ? 'true' : 'false');
          c.tabIndex = on ? 0 : -1;
        });
        if (nameEl) nameEl.innerHTML = chip.dataset.vName || '';
        if (priceEl) priceEl.textContent = chip.dataset.vPrice || '';
        if (instalEl && chip.dataset.vInstal) instalEl.textContent = chip.dataset.vInstal;
        if (stockEl) stockEl.textContent = chip.dataset.vStock || '';
        if (ctaEl && chip.dataset.vUrl) ctaEl.href = chip.dataset.vUrl;
        show(chip.dataset.vImg, chip.dataset.vName);
        if (focus) chip.focus();
      }

      chips.forEach(function (chip, i) {
        chip.addEventListener('click', function () { apply(chip, false); });
        chip.addEventListener('keydown', function (ev) {
          if (ev.key === 'Home') { ev.preventDefault(); apply(chips[0], true); return; }
          if (ev.key === 'End') { ev.preventDefault(); apply(chips[chips.length - 1], true); return; }
          var d = ev.key === 'ArrowRight' || ev.key === 'ArrowDown' ? 1
                : ev.key === 'ArrowLeft' || ev.key === 'ArrowUp' ? -1 : 0;
          if (!d) return;
          ev.preventDefault();
          apply(chips[(i + d + chips.length) % chips.length], true);
        });
      });
    });
  }


  /* ---------- 4. product page: turntable + variant ----------
     Three plates per colourway (front, three-quarter, folded) shot in the same
     position, so stepping between them reads as the frame turning. */
  function pdp() {
    var root = document.querySelector('[data-fg-pdp]');
    if (!root || root.dataset.fgBound === '1') return;
    var dataEl = root.querySelector('[data-fg-variants]');
    if (!dataEl) return;
    var V;
    try { V = JSON.parse(dataEl.textContent); } catch (e) { return; }
    root.dataset.fgBound = '1';

    var stage = root.querySelector('[data-fg-turn]');
    var dots = root.querySelector('[data-turn-dots]');
    var chips = [].slice.call(root.querySelectorAll('.fg-chip'));
    var priceEl = root.querySelector('[data-pdp-price]');
    var stockEl = root.querySelector('[data-pdp-stock]');
    var idEl = root.querySelector('[data-pdp-id]');
    var addEl = root.querySelector('[data-pdp-add]');
    var addLabel = root.querySelector('[data-pdp-add-label]');
    var instalEl = root.querySelector('[data-pdp-instalment]');
    var wash = stage ? stage.querySelector('.fg-turn2__wash') : null;

    var plates = [], idx = 0;

    function paint() {
      plates.forEach(function (p, i) { p.classList.toggle('is-on', i === idx); });
      if (!dots) return;
      [].slice.call(dots.children).forEach(function (d, i) {
        d.classList.toggle('is-on', i === idx);
      });
    }
    function step(n) {
      if (!plates.length) return;
      idx = (n + plates.length) % plates.length;
      paint();
    }

    function build(urls, alt) {
      plates.forEach(function (p) { p.remove(); });
      plates = urls.map(function (u, i) {
        var img = document.createElement('img');
        img.className = 'fg-turn2__plate';
        img.src = u;
        img.alt = i === 0 ? alt : '';
        img.decoding = 'async';
        if (i > 0) img.setAttribute('aria-hidden', 'true');
        stage.insertBefore(img, wash);
        return img;
      });
      if (dots) {
        dots.innerHTML = '';
        urls.forEach(function () { dots.appendChild(document.createElement('i')); });
      }
      idx = 0; paint();
    }

    function select(id, focus) {
      var v = V[id];
      if (!v) return;
      root.style.setProperty('--tint-top', v.top);
      root.style.setProperty('--tint-bottom', v.bottom);
      chips.forEach(function (c) {
        var on = c.dataset.vId === String(id);
        c.setAttribute('aria-checked', on ? 'true' : 'false');
        c.tabIndex = on ? 0 : -1;
        if (on && focus) c.focus();
      });
      if (priceEl) priceEl.textContent = v.price;
      if (instalEl && v.instalment) instalEl.textContent = v.instalment;
      if (stockEl) {
        stockEl.textContent = v.left <= 0 ? 'Sold out'
          : v.left === 1 ? 'Last one'
          : v.left <= 3 ? 'Only ' + v.left + ' left' : '';
      }
      if (idEl) idEl.value = id;
      if (addEl) {
        addEl.disabled = !v.available;
        if (addLabel) addLabel.textContent = v.available ? 'Add to cart' : 'Sold out';
      }
      if (v.media && v.media.length) build(v.media, v.title);
      try {
        var u = new URL(location.href);
        u.searchParams.set('variant', id);
        history.replaceState({}, '', u);
      } catch (e) {}
    }

    chips.forEach(function (chip, i) {
      chip.addEventListener('click', function () { select(chip.dataset.vId, false); });
      chip.addEventListener('keydown', function (ev) {
        var d = ev.key === 'ArrowRight' || ev.key === 'ArrowDown' ? 1
              : ev.key === 'ArrowLeft' || ev.key === 'ArrowUp' ? -1 : 0;
        if (!d) return;
        ev.preventDefault();
        select(chips[(i + d + chips.length) % chips.length].dataset.vId, true);
      });
    });

    /* pick up the plates Liquid already rendered */
    plates = [].slice.call(stage.querySelectorAll('.fg-turn2__plate'));
    if (dots) {
      plates.forEach(function () { dots.appendChild(document.createElement('i')); });
    }
    paint();

    /* drag to turn */
    var down = false, startX = 0, startIdx = 0;
    var THRESH = 46;
    stage.addEventListener('pointerdown', function (e) {
      down = true; startX = e.clientX; startIdx = idx;
      stage.setPointerCapture(e.pointerId);
    });
    stage.addEventListener('pointermove', function (e) {
      if (!down || plates.length < 2) return;
      var moved = Math.round((e.clientX - startX) / THRESH);
      if (moved !== 0) step(startIdx + moved);
    });
    ['pointerup', 'pointercancel'].forEach(function (t) {
      stage.addEventListener(t, function () { down = false; });
    });
    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); step(idx + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); step(idx - 1); }
    });

    /* one gentle turn on first view, so the affordance is discovered */
    if (!reduce.matches && 'IntersectionObserver' in window && plates.length > 1) {
      var seen = false;
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (!en.isIntersecting || seen) return;
          seen = true; io.disconnect();
          setTimeout(function () { step(1); }, 520);
          setTimeout(function () { step(0); }, 1180);
        });
      }, { threshold: 0.4 });
      io.observe(stage);
    }
  }

  function init() { reveals(); plates(); products(); pdp(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
